<template>
  <div class="container" v-if="item">
    <h1>
      Edit Rule
      <ez-modal-options class="subheader pull-right" 
        :item="item" 
        @deleteData="deleteData()" 
        @cloneData="cloneData()">
      </ez-modal-options>
    </h1>
    <item-form v-on:save-item="patchData()" :item="item" :errors="errors"></item-form>
    <p class="text-center">
      <button type="button" class="btn btn-primary" @click="patchData()">Save</button>
      <router-link class="btn btn-secondary" :to="`/rules`">Cancel</router-link>
    </p>
  </div>
</template>

<script>
import EzModalOptions from "@/components/shared/_VueEzModalOptions";
import ItemForm from "@/components/rule/_Form";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "rule-edit",
  components: {
    EzModalOptions,
    ItemForm
  },
  data() {
    return {
      errors: {}
    };
  },
  watch: {
    $route: "getData"
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapGetters({
      isAdmin: "isAdmin",
      canEdit: "rules/canEdit"
    }),
    ...mapState({
      user: state => state.session.user,
      item: state => state.rules.current
    })
  },
  methods: {
    ...mapActions({
      rulesEdit: "rules/edit",
      rulesUpdate: "rules/update",
      rulesClone: "rules/clone",
      rulesDestroy: "rules/destroy"
    }),
    async getData() {
      try {
        await this.rulesEdit({ id: this.$route.params.id });
        if (this.canEdit) {
          this.$embers.pageData(this.item.name, this.item.summary);
        } else {
          this.$router.push({ path: `/404` });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async patchData() {
      try {
        await this.rulesUpdate();
        this.$router.push({ path: `/rules/${this.item._id}` });
      } catch (err) {
        console.error(err);
        this.errors = Object.assign({}, this.errors, err.response.data);
      }
    },
    async cloneData() {
      try {
        let clone = await this.rulesClone(this.item);
        this.$router.push({ path: `/rules/${clone._id}/edit` });
      } catch (err) {
        console.error(err);
      }
    },
    async deleteData() {
      try {
        await this.rulesDestroy();
        this.$router.push({ path: `/rules` });
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
